<template>
	<CurvesPage class="curve" @onScale="drawLine">
		
		<!-- Название кривой  -->
		
		<template #curveName>Строфоида</template>
		
		<!-- модуль Характеристика кривой -->
		
		<template #curveFeature>
			
			<!-- Геометрическое место точек -->
			
			<h5 class="mt-0">
				Геометрическое место точек:
			</h5>
			<img src="@/assets/img/strophoid.jpg" class="feature__gmt">
			<p class="feature__gmt">
				<strong>Строфоида</strong>
				- множество точек <vue-mathjax :formula="viewExpression('M_{i}, i = 1, 2')" class="formula"></vue-mathjax>,
				таких, что <vue-mathjax :formula="viewExpression('BM_{1} = BM_{2} = AB')" class="formula"></vue-mathjax>,
				где <vue-mathjax :formula="viewExpression('B')" class="formula"></vue-mathjax> - точка пересечения луча,
				вращающегося вокруг точки <vue-mathjax :formula="viewExpression('O')" class="formula"></vue-mathjax>,
				с прямой, перпендикулярной оси <vue-mathjax :formula="viewExpression('OX')" class="formula"></vue-mathjax>,
				находящейся на расстоянии <vue-mathjax :formula="viewExpression('OA = a')" class="formula"></vue-mathjax>
				от точки <vue-mathjax :formula="viewExpression('O')" class="formula"></vue-mathjax>
			</p>
			
			
			<!-- Уравнение в полярных координатах -->
			
			<h5 class="mt-0">
				Полярное уравнение:
				<b-badge variant="light" class="curve__main-formula">
					<vue-mathjax
							:formula="equationInPolar"
							class="formula"
					></vue-mathjax>
				</b-badge>
			</h5>
			
			<!-- Уравнение в декартовых координатах -->
			
			<h5>Аналитическое уравнение:</h5>
			<p>
				<vue-mathjax
						:formula="equationInCartesian"
						class="formula"
				></vue-mathjax>
			</p>
			
			<h5>Параметрическое уравнение:</h5>
			<p>
				<vue-mathjax
						:formula="equationParamInCartesian" class="formula"></vue-mathjax>
			</p>
			
			<!-- Область значений для параметра -->
			
			<h5 class="mt-0">Область значений <vue-mathjax :formula="parameterT" class="formula"></vue-mathjax>:</h5>
			
			<!--
				Параметры ползунка для выбора ОДЗ параметра (!!)
				min - минимальная левая граница
				max - максимальная правая граница
				interval - шаг, с которым можно выбирать
				Для того, чтобы блокировать точки используй
				:dot-options="tDotOptions" для тега
				tDotOptions: [{            для data()
          disabled: false
        }, {
          disabled: true
        }]
			-->
			<vue-slider
					v-model="t"
					:min="-4"
			    :max="4"
			    :interval="0.1"
					@dragging="drawLine"
			></vue-slider>
			<p>
				<vue-mathjax :formula="rangeODZ" class="formula"></vue-mathjax>
			</p>
			
			<!-- Значения коэффициентов (!!) -->
			
			<h5>Зависимость от коэффициентов:</h5>
			
			<!-- Коэффициент a -->
			
			<label>
				<vue-mathjax :formula="coefficientA" class="formula"></vue-mathjax>:
			</label>
			
			<!--
				Параметры для выбора коэффициентов (!!)
				min - минимальное значение коэффициента
				max - максимальное значение коэффициента
				step - шаг, с которым можно выбирать
				disabled - если нужно заблокировать выбор
			-->
			
			<b-form-spinbutton
				  v-model="a"
				  min="-30"
		      max="30"
		      step="1"
		      @input="drawLine"
		      vertical
		      class="curve__coef"
			></b-form-spinbutton>
		
		</template>
		
		<!-- модуль Информация о кривой -->
		
		<!-- Изображение для модуля информации -->
		
		<template #curvePhoto>
			<a href="https://ru.wikipedia.org/wiki/%D0%A0%D0%BE%D0%B1%D0%B5%D1%80%D0%B2%D0%B0%D0%BB%D1%8C,_%D0%96%D0%B8%D0%BB%D1%8C"><img src="@/assets/img/strophoid_about.jpg" width="100" alt="Жиль Персонн Роберваль"></a>
		</template>
		
		<!-- Контент -->
		
		<template #curveInfo>
			<h5 class="mt-0">История:</h5>
			<p>Впервые рассмотрена <i>Ж. Робервалем</i> в 1645 г. под именем <i>птероиды</i> (в переводе с греческого "крыло"). Нынешнее название введено французским математиком <i>Миди</i> в 1849 г.</p>
			<hr>
			<p><b>Ж. Роберваль</b> - псевдоним французского учёного <i>Г Персонье(1602-1675)</i>, является одним из основоположников метода бесконечно малых, изобретатель весов, носящих его имя.</p>
		</template>
		<!--
		Выгодский М.Я. Справочник по высшей математике. Изд-во "Наука". М. 1977 г. (http://scask.ru/j_dict_math.php?id=514)
		Cправочник математических формул. Примеры и задачи с решениями (http://www.pm298.ru/spec12.php)
		-->
		<!-- модуль Задачи -->
		
		<template #curveTasks>
			<h5 class="mt-0">Примеры задач:</h5>
		</template>
	
	</CurvesPage>
</template>

<script>
	import CurvesPage, { CurvesInterface } from '@/views/templates/CurvesPage';
	
	export default {
		name: 'LemniscataBernoulli',
		mixins: [CurvesInterface],
		data () {
			return {
				/* Коэффициенты уравнения (!!) */
				a: 0,
				/* ОДЗ параметра (!!) */
				t: [0, 1]
			}
		},
		computed: {
			/* Функции для представления в latex (!!)
			 * equationInPolar - Уравнение в полярных координатах
			 * equationInCartesian - Аналитическое уравнение
			 * equationParamInCartesian - Параметрическое уравнение
			  * */
			equationInPolar: () => {
				return '$$ r = \\frac{a}{ \\cos \\theta} \\pm a \\tan \\theta $$';
			},
			equationInCartesian: () => {
				return '$$ (x^{2} + y^{2})(x - a)^{2} - a^{2}y^{2} = 0 $$';
			},
			equationParamInCartesian: () => {
				return '$$ \\begin{cases} x = \\frac{2 a t^{2} }{ 1+t^{2} } \\\\ y = \\frac{at(t^{2}-1)}{1+t^{2}} \\end{cases} $$';
			},
			/**
			 * ОДЗ (!!)
			 * Свойства возвращают реальные границы для параметра t
			 * (в том случае, если границы, выбираемые ползунком нужно преобразовать)
			 * Пример: значения определённые ползунком [0, 2], но реальные границы 0 * pi < t < 2 * pi
			 * minTheta - левая граница
			 * maxTheta - правая граница
			 * rangeODZ - представление
			 * */
			rangeODZ: (context) => {
				return '$$ ' + context.t[0] +  ' \\pi < t <' + context.t[1] + '\\pi $$';
			},
			maxTheta: ({ t }) => {
				return t[1] * Math.PI;
			},
			minTheta: ({ t }) => {
				return t[0] * Math.PI;
			}
		},
		methods: {
			/**
			 * (!!)
			 * Возвращает значение x при заданном параметре
			 * @param {number} t
			 * @return {number}
			 */
			X (t) {
				return 160 + ((2 * this.a * Math.pow(t, 2))/(1 + Math.pow(t, 2))) * this.$store.state.step;
			},
			/**
			 * (!!)
			 * Возвращает значение y при заданном параметре
			 * @param {number} t
			 * @return {number}
			 */
			Y (t) {
				return 160 + ((this.a * t * (Math.pow(t, 2) - 1))/(1 + Math.pow(t, 2))) * this.$store.state.step;
			}
		},
		components: {
			CurvesPage
		}
	}
</script>

<style scoped lang="scss">

</style>
